module.exports = __webpack_public_path__ + "img/the_golden_peacock_venetian_macao.2a7b4f02.jpg";